import {Injectable} from '@angular/core';
import {SpatialUtilService} from '../../../../services/spatial-util.service';
import {PlanModelService} from '../../../../../common/service/plan-model.service';
import {EsriModuleService} from '../../../../esri-nlr/services/esri-module.service';
import {of} from 'rxjs';
import {switchMap} from 'rxjs/operators';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
    providedIn: 'root'
})
export class ConstructionUtilService {
    title = 'ConstructionUtilService';

    constructor(
        private esriModuleService: EsriModuleService,
        private planModelService: PlanModelService,
        private spatialUtilService: SpatialUtilService
    ) {}

    getLineGeometryLength(lineGeometry: any) {
        const projectedGeometries = this.esriModuleService.projection.project(
            [lineGeometry],
            new this.esriModuleService.SpatialReference({wkid: 7844})
        );
        const lineLengths = this.esriModuleService.geodesicUtils.geodesicLengths(projectedGeometries, this.esriModuleService.units.METERS);
        return lineLengths.length && lineLengths[0] ? parseFloat(lineLengths[0].toFixed(3)) : 0;
    }

    getDistanceBetweenPoints(p0: any, p1: any) {
        const lineGeometry = this.createLineGeometry(p0, p1);
        return this.getLineGeometryLength(lineGeometry);
    }

    createLineGraphic(fromPt: any, toPt: any, lineAttributes: any) {
        const lineGeometry = this.createLineGeometry(fromPt, toPt);

        const lineGraphic = new this.esriModuleService.Graphic(lineGeometry);
        lineGraphic.attributes = lineAttributes;

        return lineGraphic;
    }

    deleteFeatures(featureLayer: any, features: any[]) {
        const featureClass = this.spatialUtilService.getFeatureClass(featureLayer);

        console.debug(`${this.title} - deleteFeatures - featureClass: ${featureClass}, feature count: ${features.length}`);

        if (features.length === 0) {
            return of(null);
        }

        // find related annotations by featureid and featuretype
        const relatedAnnotations = this.spatialUtilService.getAnnotations().filter((a: any) => {
            const attrs = a.attributes;
            return features.some(
                (f: any) =>
                    (attrs.featuretype?.toLowerCase() === featureClass && attrs.featureid === f.attributes.id) ||
                    (attrs.childtype?.toLowerCase() === featureClass && attrs.childid === f.attributes.id)
            );
        });

        const observable = relatedAnnotations.length
            ? this.applyDelete(this.spatialUtilService.getFeatureLayer('annotation'), relatedAnnotations)
            : of(null);

        return observable.pipe(switchMap(() => this.applyDelete(featureLayer, features)));
    }

    applyDelete(featureLayer: any, features: any[]) {
        if (features.length === 0) {
            return of(null);
        }

        return this.spatialUtilService.applyEdits(featureLayer, null, null, features);
    }

    updateFeatures(featureLayer: any, features: any[]) {
        if (features.length === 0) {
            return of(null);
        }

        return this.spatialUtilService.applyEdits(featureLayer, null, features, null);
    }

    private createLineGeometry(p0: any, p1: any) {
        return new this.esriModuleService.geometry.Polyline({
            paths: [
                [
                    [p0.geometry.x, p0.geometry.y],
                    [p1.geometry.x, p1.geometry.y]
                ]
            ],
            spatialReference: this.planModelService.getSpatialReference()
        });
    }
}
